import { render, staticRenderFns } from "./socialSecurityImp.vue?vue&type=template&id=488c8c90&scoped=true&"
import script from "./socialSecurityImp.vue?vue&type=script&lang=js&"
export * from "./socialSecurityImp.vue?vue&type=script&lang=js&"
import style0 from "./socialSecurityImp.vue?vue&type=style&index=0&id=488c8c90&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488c8c90",
  null
  
)

export default component.exports